module.exports = __webpack_public_path__ + "static/media/step-04.8c4965fd.png";